// Voice Provider Factory
// Creates instances of voice providers based on type

import { RetellProvider } from '#app/utils/voice-providers/retell-provider.ts'
import {
	type IVoiceAgentProvider,
	type ProviderType,
	VoiceProviderError,
} from '#app/utils/voice-providers/types.ts'

export function createVoiceProvider(type: ProviderType): IVoiceAgentProvider {
	switch (type) {
		case 'retell':
			return new RetellProvider()
		default:
			throw new VoiceProviderError(
				`Unknown provider type: ${type}`,
				'factory',
				'UNKNOWN_PROVIDER',
			)
	}
}

// Export all provider types for convenience
export { RetellProvider } from '#app/utils/voice-providers/retell-provider.ts'
export * from '#app/utils/voice-providers/types.ts'
